// API layer — connects to FastAPI backend.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BOOK_URL =
  "https://launches.aqarmap.com/ar/launches/masar-corner-alramz?utm_source=masarcornersa&utm_medium=masarcornersa&utm_campaign=developerwebsite";

export const openBooking = () => window.open(BOOK_URL, "_blank");

const authHeader = () => {
  const token = localStorage.getItem("masar_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ---- Interest / Registrations ----
export const submitInterest = async (data) => {
  const res = await axios.post(`${API}/interest`, data);
  return res.data;
};

export const getRegistrations = async () => {
  const res = await axios.get(`${API}/registrations`, { headers: authHeader() });
  return res.data;
};

// ---- Units ----
export const getUnits = async () => {
  const res = await axios.get(`${API}/units`);
  return res.data;
};

export const saveUnit = async (unit) => {
  if (unit.id) {
    const { id, ...body } = unit;
    await axios.put(`${API}/units/${id}`, body, { headers: authHeader() });
  } else {
    await axios.post(`${API}/units`, unit, { headers: authHeader() });
  }
};

export const deleteUnit = async (id) => {
  await axios.delete(`${API}/units/${id}`, { headers: authHeader() });
};

// ---- Auth ----
export const login = async (username, password) => {
  const res = await axios.post(`${API}/auth/login`, { username, password });
  localStorage.setItem("masar_token", res.data.token);
  return res.data;
};

export const isAuthed = () => !!localStorage.getItem("masar_token");
export const logout = () => localStorage.removeItem("masar_token");
